export default __webpack_public_path__ + "static/media/sc33.f5d39c3e.mp4";